<template>
  <tr class="clinic-expense" style="vertical-align:middle">
    <td class="clinic-expense__clinic ">
      {{ clinic_name }}
    </td>
    <td class="clinic-expense__date ">
      {{ pretty_date }}
    </td>
    <td class="clinic-expense__type ">
      {{ pretty_type }}
    </td>
    <td class="clinic-expense__concept ">
      {{ expense.concept }}
    </td>
    <td class="clinic-expense__amount ">
      {{ pretty_amount }}
    </td>
    <td class="clinic-expense__vat ">
      {{ pretty_vat }}
    </td>
    <td class="clinic-expense__actions d-flex align-items-center gap-10 justify-content-center ">

      <a v-if="expense.has_file" :href="expense_invoice_url" target="_blank" class="btn btn-wabident-round ml-2"
        style="font-size: 10px; padding: 5px 15px">
        <i class="fa fa-download"></i>
      </a>

      <button type="button" @click="updateExpense" class="btn btn-wabident-round ml-2"
        style="font-size: 10px; padding: 5px 15px">
        <i class="fa fa-edit"></i>
      </button>

      <button type="button" @click="deleteExpense" class="btn btn-wabident-round ml-2 red"
        style="font-size: 10px; padding: 5px 15px">
        <i class="fa fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    expense: { required: true },
    clinics: { default: null },
  },
  computed: {
    expense_invoice_url() {
      if (!this.expense.has_file) {
        return '';
      }

      return `/clinic/expenses/${this.expense.id}/invoice`;
    },
    pretty_date() {
      return moment(this.expense.expense_date).format("DD/MM/YYYY");
    },
    pretty_type() {
      if (!this.clinic) {
        return '';
      }

      return this.clinic.provider_families_dict[this.expense.provider_family_id] || '';
    },
    pretty_amount() {
      return WabiDent.fmtMoney(this.expense.amount, 0);
    },
    pretty_vat() {
      return Math.round(this.expense.vat) + '%';
    },
    clinic_name() {
      if (!this.clinics) return "";
      return this.clinics[this.expense.clinic_id] || "";
    },
    ...mapGetters(['clinic'])
  },
  methods: {
    updateExpense() {
      this.$emit("edit", this.expense);
    },
    deleteExpense() {
      this.$emit("delete", this.expense);
    },
  },
};
</script>

<style lang="scss">
.clinic-expense {
  td {
    vertical-align: middle;
  }
}
</style>
